import getGeneratorFunction from './index.js';

export default getGeneratorFunction;

export { getGeneratorFunction as 'module.exports' };
